// Candidate landing route for the conversational coding round.
// Just renders the stage — same shape as PsychoanalyticalTest / FinalInterviewTest.

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import CodingInterviewStage from "../coding/CodingInterviewStage";

const CodingInterviewTest = () => {
  const { jobId, candidateId } = useParams();
  const navigate = useNavigate();

  return (
    <CodingInterviewStage
      jobId={jobId}
      resumeId={candidateId}
      onComplete={() => {
        setTimeout(
          () => navigate("/test-complete", { state: { type: "coding" } }),
          1800
        );
      }}
    />
  );
};

export default CodingInterviewTest;
